import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";

// eslint-disable-next-line max-len
import { ServicerapportAccordionPanelModule } from "../../opgave/arbejdsgang/shared/servicerapport-accordion-panel/servicerapport-accordion-panel.module";
import { ServicerapportMaalerOplysningerComponent } from "./servicerapport-maaler-oplysninger.component";

@NgModule({
    imports: [CommonModule, MatExpansionModule, ServicerapportAccordionPanelModule],
    exports: [ServicerapportMaalerOplysningerComponent],
    declarations: [ServicerapportMaalerOplysningerComponent],
    providers: []
})
export class ServicerapportMaalerOplysningerModule {}
